/*
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   Tsx component for the DateRangeInput
 */

import React from 'react'

import { CalendarDateInputs } from './components/CalendarDateInputs'
import { CalendarMonths } from './components/CalendarMonths'
import * as style from './style'
import { Errors, SetStateDate, UndefinedOrDate, WeekStartsOn } from './types'

export interface Props {
  allErrors: Errors[]
  calendarDisplayNum?: number
  dateButtonStyle?: any
  disableForeverFrom?: Date
  disableForeverTo?: Date
  disabledRanges?: ReadonlyArray<readonly [startDate: Date, endDate: Date]>
  endDate: UndefinedOrDate
  endInputPlaceholder: string
  isMobileScrollCalendar?: boolean
  mainRef: React.MutableRefObject<HTMLDivElement | null>
  minimumStay?: number
  setDate: SetStateDate
  setEndDate: (date: UndefinedOrDate) => void
  setStartDate: (date: UndefinedOrDate) => void
  setTargetMonth: (date: Date) => void
  showDayOfWeekHeader?: boolean
  showTextInput?: boolean
  showTwoMonths?: boolean
  singleCalendar?: boolean
  startDate: UndefinedOrDate
  startInputPlaceholder: string
  subtitle?: string
  targetMonth: Date
  title?: string
  transparentBackground: boolean
  weekStartsOn: WeekStartsOn
}

export const DateRangeInputComponent = ({
  allErrors,
  calendarDisplayNum,
  dateButtonStyle,
  disableForeverFrom,
  disableForeverTo,
  disabledRanges,
  endDate,
  endInputPlaceholder,
  isMobileScrollCalendar,
  mainRef,
  minimumStay,
  setDate,
  setEndDate,
  setStartDate,
  setTargetMonth,
  showDayOfWeekHeader,
  showTextInput,
  showTwoMonths,
  singleCalendar,
  startDate,
  startInputPlaceholder,
  subtitle,
  targetMonth,
  title,
  transparentBackground,
  weekStartsOn,
}: Props) => {
  return (
    <div
      css={[style.calendarInputContainer, transparentBackground && style.transparentBackground]}
      ref={mainRef}
    >
      {showTextInput && (
        <div css={style.calendarHeaderContainer}>
          {!!subtitle && !!title && (
            <div css={style.calendarTitleContainer}>
              <p css={style.calendarTitleAndSubtitle}>
                {title} - {subtitle}
              </p>
            </div>
          )}
          <CalendarDateInputs
            endDate={endDate}
            endInputPlaceholder={endInputPlaceholder}
            errors={allErrors}
            minimumStay={minimumStay}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            startInputPlaceholder={startInputPlaceholder}
          />
        </div>
      )}
      <React.Fragment>
        <div css={style.calendarMonthsTopContainer}>
          <CalendarMonths
            calendarDisplayNum={calendarDisplayNum}
            dateButtonStyle={dateButtonStyle}
            disableForeverFrom={disableForeverFrom}
            disableForeverTo={disableForeverTo}
            disabledRanges={disabledRanges}
            endDate={endDate}
            isMobileScrollCalendar={isMobileScrollCalendar}
            setDate={setDate}
            setTargetMonth={setTargetMonth}
            showDayOfWeekHeader={showDayOfWeekHeader}
            showTwoMonths={showTwoMonths}
            singleCalendar={singleCalendar}
            startDate={startDate}
            targetMonth={targetMonth}
            weekStartsOn={weekStartsOn}
          />
        </div>
        <hr css={style.horizontalRuleBottom} />
      </React.Fragment>
    </div>
  )
}
